import axios, { AxiosError, type AxiosInstance } from 'axios'
import { ENV } from '@shared/config/env'
import { getPlatform } from '@shared/platform'

type UnauthorizedHandler = (error: AxiosError) => void

let unauthorizedHandler: UnauthorizedHandler | null = null

export const setUnauthorizedHandler = (h: UnauthorizedHandler | null) => {
  unauthorizedHandler = h
}

export const baseApi: AxiosInstance = axios.create({
  baseURL: ENV.API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
})

baseApi.interceptors.request.use((config) => {
  if (ENV.IS_TG) {
    const initData = getPlatform().getInitData()
    if (initData) {
      config.headers.set?.('Init-Data', initData)
      // fallback на случай старого формата headers:
      ;(config.headers as unknown as Record<string, string>)['Init-Data'] = initData
    }
  }
  return config
})

baseApi.interceptors.response.use(
  (r) => r,
  (error: AxiosError) => {
    if (error.response?.status === 401 && unauthorizedHandler) {
      try { unauthorizedHandler(error) } catch { /* noop */ }
    }
    return Promise.reject(error)
  }
)
